var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.isFindPositionPro ? 'pro' : 'lite',staticStyle:{"display":"inline-block"}},[_vm._v(_vm._s(_vm.position))])}
var staticRenderFns = []

export { render, staticRenderFns }